import { AxiosError } from 'axios';

const logAxiosError = (error: AxiosError): void => {
  // Attempt to log the URL if available
  const url = error.config?.url ? error.config.url : 'URL not available';

  // Gather relevant error details
  let logMessage = `Request URL: ${url}\n`;

  if (error.response) {
    logMessage += `Error data: ${JSON.stringify(error.response.data)}\n`;
    logMessage += `Error status: ${error.response.status}\n`;
    logMessage += `Error headers: ${JSON.stringify(error.response.headers)}\n`;
  } else if (error.request) {
    logMessage += `Error request: ${JSON.stringify(error.request)}\n`;
  } else {
    logMessage += `Error message: ${error.message}\n`;
  }

  logMessage += `Error config: ${JSON.stringify(error.config)}\n`;

  // Add stack trace to the log message
  const stackTrace = error.stack || new Error().stack;
  logMessage += `Stack trace: ${stackTrace}\n`;

  // Emit a single console log
  console.log(logMessage);
};

export default logAxiosError;
